export function getSubscriptionExamId(subscription) {
  if (!subscription) return null;
  const exam = subscription.exam;
  if (!exam) return null;
  if (typeof exam === "string") return exam;
  return exam._id || exam.id || null;
}

export function subscriptionMatchesExam(subscription, examId) {
  if (!subscription || !examId) return false;

  const subscriptionExamId = getSubscriptionExamId(subscription);
  if (subscriptionExamId && String(subscriptionExamId) === String(examId)) {
    return true;
  }

  const bundleExamIds = Array.isArray(subscription.bundleExams)
    ? subscription.bundleExams
        .map((examRef) => {
          if (!examRef) return null;
          if (typeof examRef === "string") return examRef;
          if (typeof examRef === "object") {
            return examRef._id || examRef.exam || null;
          }
          return null;
        })
        .filter(Boolean)
        .map(String)
    : [];

  return bundleExamIds.includes(String(examId));
}

export function isSubscriptionCurrentlyActive(subscription) {
  if (!subscription || subscription.status === false) {
    return false;
  }

  if (!subscription.expireAt) {
    return true;
  }

  const expiresOn = new Date(subscription.expireAt);
  return !Number.isNaN(expiresOn.getTime()) && expiresOn >= new Date();
}

export function clearExamSessionStorage() {
  [
    "RegSubjects",
    "examId",
    "examName",
    "examSlug",
    "logo",
    "maximumSubjects",
    "examinationType",
    "examType",
    "userSubscription",
    "categoryId",
    "courseId",
    "subjects",
    "processedSubjects",
    "universityId",
  ].forEach((key) => localStorage.removeItem(key));
}
